<div>
  <div class="img-contain">
  <img src="../../../assets/images/BANCOM-home-page.png" alt="Background image" class="img-responsive" width="600" height="400">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxHide.lt-md="true" class="img-content">
    <div fxFlex="100" fxFlexOffset="" >
      <div>
        <div>
          <span class="mat-display-2 content-view">Shape Your <b>Career</b>
            <br/> With <b>Confidence</b></span>
        </div>
        <br />
        <div class="content-view">
          <div>
            <span class="mat-title"><b>Join</b></span>
            <span class="mat-title"> Our skill development program.</span>
          </div>
          <div>
            <span class="mat-title"><b>Learn</b></span>
            <span class="mat-title"> Latest clouds based technologies.</span>
          </div>
          <div>
            <span class="mat-title"><b>Practice</b></span>
            <span class="mat-title"> Hands-on Projects & Exercises. </span>
          </div>
          <div>
            <span class="mat-title"><b>Grow</b> </span>
            <span class="mat-title"> Exponentially in your career with us.</span>
          </div>
        </div>
      </div>
    <div class="padding-20"></div>
    <div class="padding-20"></div>
    <div class="padding-20"></div>
    <div>
      <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="15%" fxHide.lt-md="true">
        <div fxFlex="25" fxFlexOffset="" class="buttonAlign">
          <button mat-flat-button color="warn" class="mat-headline large-button btn-hover color-6"
            (click)="openPopup()">
            Explorer our Programs
          </button>
          <br/>&nbsp;
        </div>
     </div>
    </div>
  </div>
</div>
</div>
</div>

<mat-card class="header" fxShow.lt-md="true" fxHide="true">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5%" fxLayoutAlign="center center" fxShow.lt-md="true"
    fxHide="true">
    <div fxFlex="70" fxFlexOffset="10">
      <div>
        <div>
          <span class="mat-display-2 introText">Shape Your <b style="color:rgb(241 115 249); font-size: 130%;">Career</b><br />
            With Confidence.</span>
        </div>
        <br />
        <div class="introSubText">
          <div>
            <span class="mat-title"><b style="color:rgb(241 115 249);">Join</b></span>
            <span class="mat-title"> Our skill development program</span>
          </div>
          <div>
            <span class="mat-title"><b style="color:rgb(241 115 249);">Learn</b></span>
            <span class="mat-title"> Latest clouds based technologies.</span>
          </div>
          <div>
            <span class="mat-title"><b style="color:rgb(241 115 249);">Practice</b></span>
            <span class="mat-title"> Hands-on Projects & Exercises </span>
          </div>
          <div>
            <span class="mat-title"><b style="color: rgb(241 115 249);">Grow</b> </span>
            <span class="mat-title"> Exponentially in your career with us.</span>
          </div>
        </div>
      </div>
    </div>
    <div fxFlex="10"></div>
  </div>

  <div>
    <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="3%" fxLayoutAlign="center center" fxShow.lt-md="true"
      fxHide="true">
      <div fxFlex="25" fxFlexOffset="10">
        <button mat-flat-button color="warn" class="mat-headline large-button btn-hover color-6" (click)="openPopup()">
          Explorer our Programs
        </button>
      </div>
    </div>
  </div>
</mat-card>
<div class="padding-10"></div>
<section>
  <div class="text-center padding-20">
    <span class="mat-display-1" style="border-bottom:1px solid white">
      Take Your <span class="card-Title bold">Developer Career</span> to New Levels
    </span>
    <div class="padding-10"></div>
    <!-- <div class="padding-20"></div> -->

    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
      <div fxFlex="15">&nbsp;</div>
      <div fxFlex="70">
        <div class="mat-title">
            BANCOM prioritizes <span class="mat-title bold">practical, project-oriented </span> as the foundation of its approach.
            By engaging in <span class="mat-title bold">internship-level projects</span>, you can acquire essential skills and<span class="mat-title bold"> gain actual work experience</span>,
            increasing your chances of securing <span class="mat-title bold">top developer positions.</span>
        </div>
      </div>
      <div fxFlex="15">&nbsp;</div>
    </div>
    <div class="padding-10"></div>
    <div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
        <div fxFlex="5">&nbsp;</div>
        <div fxFlex="90">
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center">
            <div fxFlex="25">
              <mat-card class="card-1-background card-size cardShadow">
                <mat-card-header class="text-center">
                  <mat-card-title>
                    <div class="padding-5-top-bottom">
                      <b>Project-based Learning</b>
                    </div>
                  </mat-card-title>
                </mat-card-header>
                <img mat-card-image src="../../assets/images/Bancom-Project-Based-Learning.png"
                  alt="BANCOM Project Based Learning" ngClass.lt-md="unset" />
                <mat-card-content>
                  <p class="mat-body-1 space-1">
                    Master
                    <b>Salesforce Admin or Backend development</b> through an
                    immersive project-based curriculum focused on practical
                    developer skills.
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
            <div fxFlex="25">
              <mat-card class="card-2-background card-size cardShadow">
                <mat-card-header class="text-center">
                  <mat-card-title>
                    <div class="padding-5-top-bottom"><b>Real Work Experience</b></div>
                  </mat-card-title>
                </mat-card-header>
                <img mat-card-image src="../../assets/images/Bancom-Real-Work-Experience.png"
                  alt="BANCOM Real work Experience" ngClass.lt-md="unset" />
                <mat-card-content>
                  <p class="space-1">
                    Learn with <b>real work experience</b> by building
                    internship-grade projects, with world-class mentorship, in
                    an actual developer environment.
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
            <div fxFlex="25">
              <mat-card class="card-3-background card-size cardShadow">
                <mat-card-header class="text-center">
                  <mat-card-title>
                    <div class="padding-5-top-bottom"><b>Job-ready Portfolio</b> &nbsp;</div>
                  </mat-card-title>
                </mat-card-header>
                <img mat-card-image src="../../assets/images/Bancom-Job-Ready-Portfolio.png"
                  alt="BANCOM Job Ready Portfolio" ngClass.lt-md="unset" />
                <mat-card-content>
                  <p class="space-1">
                    Go beyond just certificates with a
                    <b>BANCOM verified project portfolio</b> and impress any
                    recruiter with your skills and experience.
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
            <div fxFlex="25">
              <mat-card class="card-4-background card-size cardShadow">
                <mat-card-header class="text-center">
                  <mat-card-title>
                    <div class="padding-5-top"><b>Lifetime Career Guidance</b></div>
                  </mat-card-title>
                </mat-card-header>
                <img mat-card-image src="../../assets/images/Bancom-Lifetime-Access.png" alt="BANCOM Life-time Access"
                  ngClass.lt-md="unset" />
                <mat-card-content>
                  <p class="space-2">
                    Land exciting developer jobs with<b> structured planning</b> and
                    personalized guidance & support from BANCOM career coaches.
                  </p>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center"></div>
        </div>
        <div fxFlex="5">&nbsp;</div>
      </div>
    </div>
  </div>
  <div class="padding-20"></div>
</section>

<section class="icon_resize">
  <div class="padding-20"></div>
  <div class="text-center padding-20">
    <span class="mat-display-1" style="border-bottom:1px solid white">
      <span class="card-Title bold">Up-Skill</span> with our <span class="card-Title bold">Project-Based</span> Developer Programs
    </span>
    <div class="padding-10"></div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
      <div fxFlex="15">&nbsp;</div>
      <div fxFlex="70">
        <div class="mat-title text-center">
          With our hands-on, project-based learning method, you can land an exciting position in
          <span class="bold">Salesforce Administration</span>, or become a top-notch <span class="bold">Salesforce developer</span>,
          or either gain knowledge in structuring Salesforce <span class="bold">Commerce Cloud</span> Apps, or an Integration specialist with <span class="bold">Mulesoft.</span>
        </div>
      </div>
      <div fxFlex="15">&nbsp;</div>
    </div>
    <div class="text-center padding-20">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
      </div>
      <div class="padding-20"></div>
      <mat-card class="card-background-full-width card-1-background" style="border-radius: 2%;">
        <mat-card-header class="text-center">
          <mat-card-title>
            <div class="padding-5-top-bottom mat-headline">
              <p>Salesforce <span class="bold">Administration</span> Track</p>
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
            <div fxFlex="50">
              <p class="mat-title text-center">
                Work on guided <span class="bold">Live projects</span>
                in a real dev org. environment to <br/>master <span class="bold">Salesforce Platform Configuration.</span>
              </p>
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center" [style.background]="'rgb(171, 47, 47)'"
                class="padding-20">
                <div fxFlex="10">&nbsp;</div>
                <div fxFlex="20">
                  <div class="mat-body-2">Total Lessons</div>
                  <div>14 Lessons</div>
                </div>
                <div fxFlex="60">
                  <div class="mat-body-2">Category</div>
                  <div>Platform Configuration</div>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <br />
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center" [style.background]="'rgb(171, 47, 47)'"
                class="padding-20">
                <div fxFlex="10">&nbsp;</div>
                <div fxFlex="20">
                  <div class="mat-body-2">Duration</div>
                  <div>200+ Hours</div>
                </div>
                <div fxFlex="60">
                  <div class="mat-body-2">Career Services</div>
                  <div>In-built Career Assistance</div>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
            </div>
            <div fxFlex="50">
              <div class="padding-20"></div>
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">5+ internship-grade projects
                  </span>
                  <span class="mat-subheading-1">
                    to learn Salesforce Automation tools like Flows, Workflows, Permission Sets etc.</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <div class="padding-10"></div>


              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">30+ hands-on micro-skilling exercises
                  </span>
                  <span class="mat-subheading-1">
                    to acquire a diverse range of practical administration skills and conceptual knowledge.</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <div class="padding-10"></div>
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">Well-structured immersive workshops</span>
                  <span class="mat-subheading-1"> and live sessions from industry seasoned professionals.</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
            </div>
          </div>

          <div class="padding-20">
            <div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="15">
                  <a routerLinkActive="active">
                    <button mat-flat-button color="primary" class="mat-headline large-button btn-hover color-5"
                      (click)="openDialog('courses')">
                      Apply Now
                    </button>
                  </a>
                </div>
                <div fxFlex="15">
                  <a routerLinkActive="active">
                    <button mat-flat-button color="warn" class="mat-headline large-button btn-hover color-5"
                      routerLink="/individual-programs/sf-admin-program">
                      Learn More
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="padding-20"></div>
      <mat-card class="card-background-full-width card-2-background" style="border-radius: 2%;">
        <mat-card-header class="text-center">
          <mat-card-title>
            <div class="padding-5-top-bottom mat-headline">
              <p>Salesforce <span class="bold">Developer</span> Track</p>
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
            <div fxFlex="50">
              <p class="mat-title text-center">
              Achieve mastery in <span class="bold">Salesforce Platform Customization</span> by
              constructing <span class="bold">Real-world projects</span> within an authentic development
              environment.</p>
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center" [style.background]="'rgb(64, 133, 41)'"
                class="padding-20">
                <div fxFlex="10">&nbsp;</div>
                <div fxFlex="20">
                  <div class="mat-body-2">Total Lessons</div>
                  <div>30 Lessons</div>
                </div>
                <div fxFlex="60">
                  <div class="mat-body-2">Category</div>
                  <div>Platform Customization</div>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <br />
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center" [style.background]="'rgb(64, 133, 41)'"
                class="padding-20">
                <div fxFlex="10">&nbsp;</div>
                <div fxFlex="20">
                  <div class="mat-body-2">Duration</div>
                  <div>350+ Hours</div>
                </div>
                <div fxFlex="60">
                  <div class="mat-body-2">Career Services</div>
                  <div>In-built Career Assistance</div>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
            </div>
            <div fxFlex="50">
              <div class="padding-20"></div>
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">7+ internship-grade projects</span>
                  <span class="mat-subheading-1">
                    to learn Apex, Triggers, Integrations etc.</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <div class="padding-10"></div>

              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">45+ hands-on micro-skilling exercises
                  </span>
                  <span class="mat-subheading-1">
                    to learn a variety of concepts, development best practices and practical developer
                    skills</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <div class="padding-10"></div>

              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">Curated, concept-wise designed curriculum
                  </span>
                  <span class="mat-subheading-1">
                    with mock-tests to crack interview rounds with ease.</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
            </div>
          </div>

          <div class="padding-20">
            <div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="15">
                  <a routerLinkActive="active">
                    <button mat-flat-button color="primary" class="mat-headline large-button btn-hover color-5"
                      (click)="openDialog('courses')">
                      Apply Now
                    </button>
                  </a>
                </div>
                <div fxFlex="15">
                  <a routerLinkActive="active">
                    <button mat-flat-button color="warn" class="mat-headline large-button btn-hover color-5"
                      routerLink="/individual-programs/sf-developer-program">
                      Learn More
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="padding-20"></div>
      <mat-card class="card-background-full-width card-3-background" style="border-radius: 2%;">
        <mat-card-header class="text-center">
          <mat-card-title>
            <div class="padding-5-top-bottom mat-headline">
              <p><span class="bold">Vlocity/OmniStudio</span> Developer Track</p>
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
            <div fxFlex="50">
              <p class="mat-title text-center">
                Become a <span class="bold">skilled Vlocity/OmniStudio developer</span> with hands-on
                experience in building a scalable <span class="bold">industry cloud based App.</span>
              </p>
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center" [style.background]="'rgb(217 191 66)'"
                class="padding-20">
                <div fxFlex="10">&nbsp;</div>
                <div fxFlex="20">
                  <div class="mat-body-2">Total Lessons</div>
                  <div>5 Lessons</div>
                </div>
                <div fxFlex="60">
                  <div class="mat-body-2">Category</div>
                  <div>Industry Cloud</div>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <br />
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center" [style.background]="'rgb(217 191 66)'"
                class="padding-20">
                <div fxFlex="10">&nbsp;</div>
                <div fxFlex="20">
                  <div class="mat-body-2">Duration</div>
                  <div>220+ Hours</div>
                </div>
                <div fxFlex="60">
                  <div class="mat-body-2">Career Services</div>
                  <div>In-built Career Assistance</div>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
            </div>
            <div fxFlex="50">
              <div class="padding-20"></div>
              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">6+ internship-grade projects
                  </span>
                  <span class="mat-subheading-1">
                    to learn Omniscript, DataRaptors, FlexCards, Integration Procedures and more.</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <div class="padding-10"></div>

              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">25+ hands-on micro-skilling exercises
                  </span>
                  <span class="mat-subheading-1">
                    to gain hands-on experience and a broad range of developer skills and conceptual knowledge.</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
              <div class="padding-10"></div>


              <div fxLayout="row" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="12">
                  <mat-icon>star</mat-icon>
                </div>
                <div fxFlex="85" class="text-left">
                  <span class="mat-subheading-2">Meticulously compiled curriculum structured</span>
                  <span class="mat-subheading-1">by concepts and complemented by practice exams to effortlessly
                   perform Routine task at work.</span>
                </div>
                <div fxFlex="10">&nbsp;</div>
              </div>
            </div>
          </div>

          <div class="padding-20">
            <div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center">
                <div fxFlex="15">
                  <a routerLinkActive="active">
                    <button mat-flat-button color="primary" class="mat-headline large-button btn-hover color-5"
                      (click)="openDialog('courses')">
                      Apply Now
                    </button>
                  </a>
                </div>
                <div fxFlex="15">
                  <a routerLinkActive="active">
                    <button mat-flat-button color="warn" class="mat-headline large-button btn-hover color-5"
                      routerLink="/individual-programs/vlocity-program">
                      Learn More
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="padding-20"></div>
    <div class="padding-20"></div>
    <div>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center">
        <div fxFlex="25">
          <button mat-flat-button color="primary" class="mat-headline large-button btn-hover color-11-full"
            routerLink="/individual-programs">
            Find A Suitable Program for You.
          </button>
        </div>
      </div>
    </div>
    <div class="padding-20"></div>
  </div>
</section>

<div class="padding-20"></div>

<section class="highlighted-background-foreground-1 skew content-view">
  <div class="section">
    <div class="padding-20"></div>
    <div class="padding-20"></div>
    <div class="text-center padding-20 ">
      <span class="mat-display-1 underline2">BANCOM <span class="bold">Career Services</span> </span>
    </div>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
      <div fxFlex="15">&nbsp;</div>
      <div fxFlex="70">
        <div class="mat-title text-center bold">
          All our developer programs come with career services that will equip
          you to use your learnings and skills to ace your next interview or
          excel in your current role.
        </div>
      </div>
      <div fxFlex="15">&nbsp;</div>
    </div>
    <div class="padding-10"></div>
    <div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
        <div fxFlex="70" fxFlex.lt-md="60" class="padding-20">
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center">
            <div fxFlex="30">
              <mat-card class="card-1-background card-size cardShadow">
                <div class="padding-7" ngClass.lt-sm="padding-20 padding-10"></div>
                <div class="text-center">
                  <img mat-card-image src="../../assets/images/Bancom-Career-Planning-Coaching.png"
                    alt="BANCOM Career Planning & Coaching" ngClass.lt-md="unset" />
                </div>
                <div class="padding-7"></div>
                <mat-card-header class="text-center">
                  <mat-card-title class="card-Title">
                    <div class="padding-5-top-bottom">
                      Career Planning & Coaching
                    </div>
                  </mat-card-title>
                </mat-card-header>

                <mat-card-content class="text-center">
                  <ul class="list-item padding-5">
                    <li>S.M.A.R.T goal setting</li>
                    <li>Personalised career planning</li>
                    <li>Group sessions with career coaches</li>
                  </ul>
                  <div class="padding-7"></div>
                </mat-card-content>
              </mat-card>
            </div>
            <div fxFlex="30">
              <mat-card class="card-2-background card-size cardShadow">
                <div class="padding-7"></div>
                <div class="text-center">
                  <img mat-card-image src="../../assets/images/Bancom-Profile-Readiness-Job-Search-Support.png"
                    alt="Bancom Profile Readiness & Job Search Support" ngClass.lt-md="unset" />
                </div>
                <div class="padding-7"></div>
                <mat-card-header class="text-center">
                  <mat-card-title class="card-Title">
                    <div class="padding-5-top-bottom">
                      Profile Readiness & Job Search Support
                    </div>
                  </mat-card-title>
                </mat-card-header>

                <mat-card-content class="text-center">
                  <ul class="list-item padding-5">
                    <li>Resume and LinkedIn profile review</li>
                    <li>Tips & hacks to get noticed by recruiters</li>
                    <li>Curated job opportunities to apply</li>
                  </ul>
                  <div class="padding-7"></div>
                </mat-card-content>
              </mat-card>
            </div>
            <div fxFlex="30">
              <mat-card class="card-3-background card-size cardShadow">
                <div class="padding-7"></div>
                <div class="text-center">
                  <img mat-card-image src="../../assets/images/Bancom-Referrals-Placement-Guarantee.png"
                    alt="BANCOM Referrals and Placement Guarantee" ngClass.lt-md="unset" />
                </div>
                <div class="padding-7"></div>
                <mat-card-header class="text-center">
                  <mat-card-title class="card-Title">
                    <div class="padding-5-top-bottom">
                      Referrals & Placement Assistance
                    </div>
                  </mat-card-title>
                </mat-card-header>

                <mat-card-content class="text-center">
                  <ul class="list-item padding-5">
                    <li>Assured referrals to exciting dev roles</li>
                    <li>
                      Placement Assistance after program completion
                    </li>
                  </ul>
                  <div class="padding-7"></div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="3%" fxLayoutAlign="center"></div>
        </div>
      </div>
    </div>
    <!-- <div class="padding-20"></div>
    <div class="padding-20"></div> -->
    <div class="padding-20"></div>
    <div class="padding-20"></div>
  </div>
</section>

<section>
  <div class="section" fxHide.lt-md="true">
    <div class="padding-20"></div>
    <div class="padding-20"></div>
    <div class="padding-20"></div>
    <div class="text-center padding-20">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
        <div fxFlex="30" class="text-right">
          <img src="../../assets/images/Bancom-Have_Any_Ques.png" alt="BANCOM Have Any Ques" width="300px" />
        </div>
        <div fxFlex="50">
          <div class="padding-20"></div>
          <span class="mat-display-1"> Have any further <b>questions?</b> </span>
          <div class="padding-20"></div>
          <a routerLinkActive="active">
            <button mat-flat-button color="warn" class="mat-headline btn-hover color-4" routerLink="/contact-us">
              Contact Us
            </button>
          </a>
        </div>
      </div>
    </div>
    <div class="padding-20"></div>
  </div>
</section>


<mat-card class="section" fxShow.lt-md="true" fxHide="true">
  <!-- <div class="padding-20"></div> -->
  <!-- <div class="padding-20"></div>
  <div class="padding-20"></div> -->
  <div class="text-center padding-20">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="3%" fxLayoutAlign="center">
      <div fxFlex="50" class="text-center">
        <img src="../../assets/images/Bancom-Have_Any_Ques.png" alt="BANCOM Have Any Ques" width="300px" />
      </div>
      <div fxFlex="50" class="text-center">
        <div class="padding-20"></div>
        <span class="mat-display-1"> Have any further questions? </span>
        <div class="padding-20"></div>
        <a routerLinkActive="active">
          <button mat-flat-button color="warn" class="mat-headline btn-hover color-4" routerLink="/contact-us">
            Contact Us
          </button>
        </a>
      </div>
    </div>
  </div>
  <!-- <div class="padding-20"></div> -->
</mat-card>


<div class="padding-20"></div>

<section class="highlighted-background-foreground-2 anti-skew">
  <div class="section">
    <div class="padding-20"></div>
    <div class="padding-20"></div>

    <div class="padding-20">
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5%" fxLayoutAlign="left">
        <div fxFlex="45" class="text-right">
          <div class="mat-display-1 no-margin">Real</div>
          <div class="mat-display-2 no-margin">Work experience</div>
        </div>
        <div fxFlex="30" class="text-left">
          <span class="mat-title" style="font-weight:370">
            Existing ways of learning through video-based courses or expensive bootcamps aren't as effective when it comes to solving real-world tech problems. The ability to physically attend a training, engage in face-to-face discussions with peers and instructors, and participate in hands-on projects can lead to a deeper understanding of the subject matter.
          </span>
        </div>
      </div>
      <div class="padding-20"></div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5%" fxLayoutAlign="left" fxShow="true">
        <div fxFlex="45" class="text-right">
          <div class="mat-display-1 no-margin">Real</div>
          <div class="mat-display-2 no-margin">Project-based learning</div>
        </div>
        <div fxFlex="30" class="text-left">
          <span class="mat-title" style="font-weight:370">
            Recruiters too, look for industry-project experience when hiring developers and here at Bancom, we strive to provide just that. We empower developers with high quality applied learning opportunities and build skills that translate into career growth and success.
          </span>
        </div>
      </div>
      <div class="padding-20"></div>
      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5%" fxLayoutAlign="left" fxShow="true">
        <div fxFlex="45" class="text-right">
          <div class="mat-display-1 no-margin">Real</div>
          <div class="mat-display-2 no-margin">Skill development</div>
        </div>
        <div fxFlex="30" class="text-left">
          <span class="mat-title" style="font-weight:370">
            Our curriculum is up-to-date and relevant to the current job market, equipping our learners with the skills and knowledge needed to thrive in their chosen professions.
          </span>
        </div>
      </div>

      <div class="padding-20"></div>
      <div class="padding-20"></div>

      <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="5%" fxLayoutAlign="center">
        <div fxFlex="65" class="text-center">
          <img width="100%" src="../../assets/images/Bancom-Comparison-Table.png"
            alt="BANCOM Bancom Comparison Table" />
        </div>
      </div>
      <div class="padding-20"></div>
    </div>
  </div>
</section>

<div>
  <div class="padding-20"></div>
  <div class="text-center">
    <span class="text-center mat-display-1">FAQ's</span>
  </div>
  <div class="padding-20"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title> Who should join BANCOM? </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Everyone who wants to advance their career in <b>Salesforce</b>. It is open to students 
            and working professionals.
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Where the training would be conducted? Is any accomodation is provided from the organization?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>The training would be conducted offline in the corporate environment at our training center in Noida.
          You can check the details of our center at "Contact Us Page".</p>
          <p> No, there would not be any accomodation facilities from the orgainzation. </p>
          
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              What is the duration of the course?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>Total duration is aound: 3 months/540 hours</p>
          <p>Weekend (Saturday and Sunday) and public holidays: closed</p>
          <p>Working days timings: 9am to 6pm</p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              What is the fee for the program?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>Due to the sensitive nature of this information, we will provide details regarding the fee 
            during the inquiry session or when you visit the center. </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              How is this program diffrent from other online courses?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Existing ways of learning - video-based courses or expensive
            bootcamps, don’t provide the real skill development needed when
            working in a top tech company. Bancom’s project-based learning
            allows you to work on internship-grade projects and multiple
            hands-on activities in a real developer environment to learn new
            skills.
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Is any certification granted at the end?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>Yes, you will receive a BANCOM Program completion certificate along with a 
            verified GitHub page. The GitHub page will be a personalised profile to showcase 
            the details of the work you completed in the program. </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Can I get EMI if I don't have Credit Card?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Yes, you can. No-cost EMI and low-cost EMI options are available through our banking partners.
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Which companies should I priotise for placement, after BANCOM course completion ?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p> 
            Our career team helps you find the right career opportunity through a combination
             of direct referrals, and identifying opportunities that you can apply to.
             Job opportunities span across tech MNCs and exciting product-based tech startups.
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
  <div fxLayout="row" fxLayout.xs="column">
    <div fxFlex="15"></div>
    <div fxFlex="70">
      <mat-accordion>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Is there any assistance from BANCOM after completion of Certificate Course?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            Of Course! BANCOM placement team not only help you in getting first placement but 
             assist you lifetime in getting better placement. 
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div fxFlex="15"></div>
  </div>
  <div class="padding-10"></div>
</div>
